<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->


      <div class="navbar-brand-box">
        <!-- <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="17">
          </span>
        </a> -->

        <a href="https://www.nabh.co/" class="logo logo-light">
          <span class="logo-lg logo-nabh">
            <img src="assets/images/ayush-img/nabh_logo_top.png" />
          </span>
          <h3 class="title-nabh">ECHS & CGHS Empanelment</h3>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar()">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <!-- <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="Search...">
          <span class="bx bx-search-alt"></span>
        </div>
      </form> -->

      <!-- <div class="dropdown dropdown-mega d-none d-lg-block ml-2" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle>
          Mega Menu
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <div class="dropdown-menu dropdown-megamenu" ngbDropdownMenu>
          <div class="row">
            <div class="col-sm-8">

              <div class="row">
                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">UI Components</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">Lightbox</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Range Slider</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Sweet Alert</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Rating</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Forms</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Tables</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Charts</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">Applications</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">Ecommerce</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Calendar</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Email</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Projects</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Tasks</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Contacts</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">Extra Pages</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">Light Sidebar</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Compact Sidebar</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Horizontal layout</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Maintenance</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Coming Soon</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Timeline</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">FAQs</a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="font-size-14 mt-0">UI Components</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">Lightbox</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Range Slider</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Sweet Alert</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Rating</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Forms</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Tables</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Charts</a>
                    </li>
                  </ul>
                </div>

                <div class="col-sm-5">
                  <div>
                    <img src="assets/images/megamenu-img.png" alt="" class="img-fluid mx-auto d-block">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

    </div>

    <div class="d-flex">

      <!-- <div class="dropdown d-inline-block d-lg-none ml-2" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" ngbDropdownToggle>
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" ngbDropdownMenu>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div> -->

      <!-- <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle>
          <img class="" src="assets/images/flags/us.jpg" alt="Header Language" height="16">
        </button>
        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu> -->

      <!-- item-->
      <!-- <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="assets/images/flags/spain.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">Spanish</span>
          </a> -->

      <!-- item-->
      <!-- <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="assets/images/flags/germany.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">German</span>
          </a> -->

      <!-- item-->
      <!-- <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="assets/images/flags/italy.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">Italian</span>
          </a> -->

      <!-- item-->
      <!-- <a href="javascript:void(0);" class="dropdown-item notify-item">
            <img src="assets/images/flags/russia.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">Russian</span>
          </a>
        </div>
      </div> -->

      <!-- <div class="dropdown d-none d-lg-inline-block ml-1" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" ngbDropdownToggle>
          <i class="bx bx-customize"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" ngbDropdownMenu>
          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/github.png" alt="Github">
                  <span>GitHub</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                  <span>Bitbucket</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dribbble.png" alt="dribbble">
                  <span>Dribbble</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dropbox.png" alt="dropbox">
                  <span>Dropbox</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp">
                  <span>Mail Chimp</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/slack.png" alt="slack">
                  <span>Slack</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="dropdown d-none d-lg-inline-block ml-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div> -->

      <!-- <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
          ngbDropdownToggle>
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge badge-danger badge-pill">3</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0"> Notifications </h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small"> View All</a>
              </div>
            </div>
          </div>
          <perfect-scrollbar style="height: 230px;" [config]="configData">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Your order is placed</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">If several languages coalesce the grammar</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 min ago</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-3.jpg" class="mr-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">James Lemire</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">It will seem like simplified English.</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 hours ago</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span class="avatar-title bg-success rounded-circle font-size-16">
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Your item is shipped</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">If several languages coalesce the grammar</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 min ago</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-4.jpg" class="mr-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Salena Layfield</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 hours ago</p>
                  </div>
                </div>
              </div>
            </a>
          </perfect-scrollbar>
          <div class="p-2 border-top">
            <a class="btn btn-sm btn-link font-size-14 btn-block text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle mr-1"></i> View More..
            </a>
          </div>
        </div>
      </div> -->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <img class="rounded-circle header-profile-user" src="assets/images/users/avatar-1.png" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ml-1"
            style="font-size: 14px; color: #fff; position: relative; top:2px">{{username}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"
            style="position: relative; top: 4px; margin-left: 3px;"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
          <!-- item-->


          <a class="dropdown-item" routerLink="/password-change" routerLinkActive="active"><i
              class="bx bx-user font-size-16 align-middle mr-1"></i>
            Change Password</a>
          <!-- <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-wallet font-size-16 align-middle mr-1"></i> My Wallet</a>
          <a class="dropdown-item d-block" href="javascript: void(0);"><span
              class="badge badge-success float-right">11</span><i
              class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings</a> -->
          <!-- <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-lock-open font-size-16 align-middle mr-1"></i> Lock
            screen</a> -->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-red" href="javascript: void(0);" (click)="logout()"><i
              class=" bx bx-power-off font-size-16 align-middle mr-1 text-red"></i> Logout</a>
        </div>
      </div>

      <!-- <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="onSettingsButtonClicked()">
          <i class="bx bx-cog bx-spin"></i>
        </button>
      </div> -->
    </div>
  </div>
</header>
<div class="topnav">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">

      <div class="collapse navbar-collapse active" id="topnav-menu-content">
        <ul class="navbar-nav">
          <!-- <li class="nav-item" *ngIf="currentUser.roleId==2">
            <a class="nav-link side-nav-link-ref" routerLink="/admindashboard" routerLinkActive="active">
              <i class="bx bx-home-circle mr-2"></i>Dashboard
            </a>
          </li> -->





          <!-- new menu dynamic start  -->

          <!-- <li class="nav-item dropdown" *ngFor="let item of menudy">
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-pages" role="button"
              (click)="onMenuClick($event)">
              <i class="bx bx-customize mr-2"></i>{{item.name}} <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu" *ngIf="item.children.length>0">
              <span *ngFor="let itm of item.children">
                <a routerLink="/calendar" class="dropdown-item side-nav-link-ref"
                  routerLinkActive="active">{{itm.name}}</a>
                
              </span>

            </div>
          </li> -->

          <li class="nav-item" *ngFor="let item of menudy">
            <!-- <a class="nav-link side-nav-link-ref" routerLink="{{item.url}}" routerLinkActive="active"
              style="padding: 12px 12px;">
              <i [ngClass]="item.icon" class="mr-2"></i>{{item.name}}<span class="text-danger" *ngIf="(this.currentUser.roleId==1||this.currentUser.roleId==2||this.currentUser.roleId==3||this.currentUser.roleId==5) && item.name.trim()=='Remarks' && unread_msg_count!=undefined && unread_msg_count>0">{{unread_msg_count}}</span>
            </a> -->

            <a class="nav-link side-nav-link-ref" *ngIf="!(item.url.includes('.pdf'))" routerLink="{{item.url}}"
              routerLinkActive="active" style="padding: 14px 12px;">
              <i [ngClass]="item.icon" class="mr-2"></i>{{item.name}}<span class="text-danger"
                *ngIf="(this.currentUser.roleId==1||this.currentUser.roleId==2||this.currentUser.roleId==3||this.currentUser.roleId==5) && item.name.trim()=='Remarks' && unread_msg_count!=undefined && unread_msg_count>0">{{unread_msg_count}}</span>
            </a>
            <span *ngIf="item.id != 40 && item.url.includes('.pdf')" > <!-- except asr Notice -->
            <a class="nav-link side-nav-link-ref" *ngIf="item.url.includes('.pdf')" routerLinkActive="active"
              href="{{item.url}}" style="padding: 14px 12px;" target="_blank">
              <i [ngClass]="item.icon" class="mr-2"></i>{{item.name}}<span class="text-danger"
                *ngIf="(this.currentUser.roleId==1||this.currentUser.roleId==2||this.currentUser.roleId==3||this.currentUser.roleId==5) && item.name.trim()=='Remarks' && unread_msg_count!=undefined && unread_msg_count>0">{{unread_msg_count}}</span>
            </a>
            </span>
            <span *ngIf="item.id == 40 && item.url.includes('.pdf') && this.currentUser.roleId==5" > <!-- asr Notice -->
              <a class="nav-link side-nav-link-ref blink_me" *ngIf="item.url.includes('.pdf')" href="{{item.url}}"
                target="_blank" routerLinkActive="" style="padding: 14px 12px; color: red;">
                <i [ngClass]="item.icon" class="mr-2"></i>{{item.name}}
              </a>
          </span>
          </li>



          <!-- </ng-tamplete> -->



          <!-- new menu dynamic end  -->

          <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle arrow-none" (click)="onMenuClick($event)" href="javascript: void(0);"
              id="topnav-components" role="button">
              <i class="bx bx-tone mr-2"></i>UI Elements <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu mega-dropdown-menu px-2 dropdown-mega-menu-xl"
              aria-labelledby="topnav-components">
              <div class="row">
                <div class="col-lg-4">
                  <div>
                    <a routerLink="/ui/alerts" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Alerts</a>
                    <a routerLink="/ui/buttons" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Buttons</a>
                    <a routerLink="/ui/cards" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Cards</a>
                    <a routerLink="/ui/carousel" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Carousel</a>
                    <a routerLink="/ui/dropdowns" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Dropdowns</a>
                    <a routerLink="/ui/grid" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Grid</a>

                  </div>
                </div>
                <div class="col-lg-4">
                  <div>
                    <a routerLink="/ui/images" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Images</a>
                    <a routerLink="/ui/modals" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Modals</a>
                    <a routerLink="/ui/rangeslider" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Range Slider</a>
                    <a routerLink="/ui/progressbar" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Progress Bars</a>
                    <a routerLink="/ui/sweet-alert" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Sweet-Alert</a>
                    <a routerLink="/ui/tabs-accordions" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Tabs &amp;
                      Accordions</a>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div>
                    <a routerLink="/ui/typography" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Typography</a>
                    <a routerLink="/ui/video" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Video</a>
                    <a routerLink="/ui/general" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">General</a>
                    <a routerLink="/ui/colors" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Colors</a>
                    <a routerLink="/ui/image-crop" class="dropdown-item side-nav-link-ref"
                      routerLinkActive="active">Image Cropper</a>
                  </div>
                </div>
              </div>
            </div>
          </li>


          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-pages" role="button"
              (click)="onMenuClick($event)">
              <i class="bx bx-customize mr-2"></i>Apps <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu">

              <a routerLink="/calendar" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Calendar</a>
              <a routerLink="/chat" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Chat</a>

              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-email"
                  role="button" (click)="onMenuClick($event)">
                  Email <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-email">
                  <a routerLink="/email/inbox" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Inbox</a>
                  <a routerLink="/email/read" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Read
                    Email</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-ecommerce"
                  role="button" (click)="onMenuClick($event)">
                  Ecommerce <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-ecommerce">
                  <a routerLink="/ecommerce/products" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Products</a>
                  <a routerLink="/ecommerce/product-detail" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Product Detail</a>
                  <a routerLink="/ecommerce/orders" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Orders</a>
                  <a routerLink="/ecommerce/customers" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Customers</a>
                  <a routerLink="/ecommerce/cart" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Cart</a>
                  <a routerLink="/ecommerce/checkout" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Checkout</a>
                  <a routerLink="/ecommerce/shops" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Shops</a>
                  <a routerLink="/ecommerce/add-product" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Add Product</a>
                </div>
              </div>

              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-project"
                  role="button" (click)="onMenuClick($event)">
                  Projects <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-project">
                  <a routerLink="/projects/grid" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Projects Grid</a>
                  <a routerLink="/projects/list" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Projects List</a>
                  <a routerLink="/projects/overview" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Project Overview</a>
                  <a routerLink="/projects/create" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Create New</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-task"
                  role="button" (click)="onMenuClick($event)">
                  Tasks <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-task">
                  <a routerLink="/tasks/list" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Task
                    List</a>
                  <a routerLink="/tasks/kanban" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Kanban
                    Board</a>
                  <a routerLink="/tasks/create" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Create
                    Task</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-contact"
                  role="button" (click)="onMenuClick($event)">
                  Contacts <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-contact">
                  <a routerLink="/contacts/grid" class="dropdown-item side-nav-link-ref" routerLinkActive="active">User
                    Grid</a>
                  <a routerLink="/contacts/list" class="dropdown-item side-nav-link-ref" routerLinkActive="active">User
                    List</a>
                  <a routerLink="/contacts/profile" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Profile</a>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-charts" role="button"
              (click)="onMenuClick($event)">
              <i class="bx bx-collection mr-2"></i>Components <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu" aria-labelledby="topnav-charts">
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-form"
                  role="button" (click)="onMenuClick($event)">
                  Forms <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-form">
                  <a routerLink="/form/elements" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Elements</a>
                  <a routerLink="/form/validation" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Form Validation</a>
                  <a routerLink="/form/advanced" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Advanced</a>
                  <a routerLink="/form/editor" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Editors</a>
                  <a routerLink="/form/uploads" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    File Upload</a>
                  <a routerLink="/form/repeater" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Repeater</a>
                  <a routerLink="/form/wizard" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Wizard</a>
                  <a routerLink="/form/mask" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Form
                    Mask</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-table"
                  role="button" (click)="onMenuClick($event)">
                  Tables <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-table">
                  <a routerLink="/tables/basic" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Basic
                    Tables</a>
                  <a routerLink="/tables/advanced" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Advanced Table</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-table"
                  role="button" (click)="onMenuClick($event)">
                  Charts <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-table">
                  <a routerLink="/charts/apex" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Apex
                    charts</a>
                  <a routerLink="/charts/chartjs" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Chartjs Chart</a>
                  <a routerLink="/charts/chartist" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Chartist Chart</a>
                  <a routerLink="/charts/echart" class="dropdown-item side-nav-link-ref" routerLinkActive="active">E -
                    Chart</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-table"
                  role="button" (click)="onMenuClick($event)">
                  Icons <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-table">
                  <a routerLink="/icons/boxicons" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Boxicons</a>
                  <a routerLink="/icons/materialdesign" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Material Design</a>
                  <a routerLink="/icons/dripicons" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Dripicons</a>
                  <a routerLink="/icons/fontawesome" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Font awesome</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-map"
                  role="button" (click)="onMenuClick($event)">
                  Maps <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-map">
                  <a routerLink="/maps/google" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Google
                    Maps</a>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-more" role="button"
              (click)="onMenuClick($event)">
              <i class="bx bx-file mr-2"></i>Extra pages <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu" aria-labelledby="topnav-more">
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-invoice"
                  role="button" (click)="onMenuClick($event)">
                  Invoices <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-invoice">
                  <a routerLink="/invoices/list" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Invoice List</a>
                  <a routerLink="/invoices/detail" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Invoice Detail</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-auth"
                  role="button" (click)="onMenuClick($event)">
                  Authentication <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-auth">
                  <a routerLink="/pages/login-1" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Login</a>
                  <a routerLink="/pages/register-1" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Register</a>
                  <a routerLink="/pages/recoverpwd-1" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Recover Password</a>
                  <a routerLink="/pages/lock-screen-1" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Lock Screen</a>
                </div>
              </div>
              <div class="dropdown">
                <a class="dropdown-item dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-utility"
                  role="button" (click)="onMenuClick($event)">
                  Utility <div class="arrow-down"></div>
                </a>
                <div class="dropdown-menu" aria-labelledby="topnav-utility">
                  <a routerLink="/pages/starter" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Starter Page</a>
                  <a routerLink="/pages/maintenance" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Maintenance</a>
                  <a routerLink="/pages/timeline" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Timeline</a>
                  <a routerLink="/pages/faqs" class="dropdown-item side-nav-link-ref" routerLinkActive="active">FAQs</a>
                  <a routerLink="/pages/pricing" class="dropdown-item side-nav-link-ref"
                    routerLinkActive="active">Pricing</a>
                  <a routerLink="/pages/404" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Error
                    404</a>
                  <a routerLink="/pages/500" class="dropdown-item side-nav-link-ref" routerLinkActive="active">Error
                    500</a>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-layout" role="button"
              (click)="onMenuClick($event)">
              <i class="bx bx-layout mr-2"></i>Layouts <div class="arrow-down"></div>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="topnav-layout">
              <a href="javascript: void(0);" class="dropdown-item" (click)="changeLayout('vertical')">Vertical</a>
              <a href="javascript: void(0);" class="dropdown-item" (click)="topbarLight()">Topbar light</a>
              <a href="javascript: void(0);" class="dropdown-item" (click)="boxedWidth()">Boxed width</a>
              <a href="javascript: void(0);" class="dropdown-item" (click)="coloredHeader()">Colored Header</a>
            </div>
          </li> -->

        </ul>
      </div>
    </nav>
  </div>
</div>
